'use client';

import React from 'react';
import NewBonusDefinitionContent from '@/app/dashboard/bonus/bonus-definition/components/new-bonus-definition-content';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { getUi, hideDrawerState } from '@/store/reducers/ui-slice';

import { GeneralDrawer } from '@/types/general';

import DrawerTemplate from '../core/drawer-template';

export default function NewBonusDefinitionDrawer(): React.JSX.Element | null {
  const { drawerState } = useAppSelector(getUi);

  const dispatch = useAppDispatch();

  return (
    <DrawerTemplate
      open={drawerState.NEW_BONUS_DEFINITION}
      onClose={() => {
        dispatch(hideDrawerState(GeneralDrawer.NEW_BONUS_DEFINITION));
      }}
      title="New Bonus Definition"
      width="830px"
    >
      <NewBonusDefinitionContent />
    </DrawerTemplate>
  );
}
